var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-vulnerabilities"},[_c('div',{staticClass:"no-vulnerabilities__container"},[_c('div',{staticClass:"no-vulnerabilities__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"no-vulnerabilities__description",domProps:{"innerHTML":_vm._s(_vm.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }